/* shop.js: builder A. Department, Bestsellers and New Arrivals pages and the search page (the prototype's
   site/js/shop.js on Shopify data). Loaded by layout/theme.liquid on collection templates other than the brand
   templates, and on search. Uses window.ML.
   The page is server rendered and every state is a URL: storefront filters (Shopify's url_to_add / url_to_remove),
   sort_by and the Product type chips. This script fetches those URLs with the Section Rendering API (section_id),
   swaps the parts marked data-sh-part (chips, bar, grid, head) and keeps the address bar in step (back works).
   It draws the desktop filter menus, the Sort menu and the phone filter sheet from the JSON block in the bar
   (snippets/shop-filters.liquid). Show more first reveals the cards CSS holds back at rest (the board's first
   screen), then appends the next page. Quick add: a single-variant product goes to the cart through the shared
   [data-qadd] handler (site.js, ML.add); a product with choices opens its page, which opens on the first
   variant in stock. */
(function () {
  'use strict';
  var ML = window.ML;
  if (!ML) return;
  var mqL = ML.mqL || window.matchMedia('(min-width:1024px)');
  var TICK = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#3D3129" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M2.2 6.3l2.4 2.4 5.2-5.4"/></svg>';
  var CHEV_D = '<svg class="sh-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var X_LG = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="#3D3129" stroke-width="1.4" aria-hidden="true" focusable="false"><path d="M2.6 2.6l12.8 12.8M15.4 2.6L2.6 15.4"/></svg>';
  var BANDS = [['Under $100', null, 99.99], ['$100 to $250', 100, 249.99], ['$250 to $500', 250, 499.99], ['$500 and up', 500, null]];
  var GTE = 'filter.v.price.gte', LTE = 'filter.v.price.lte';

  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function plural(n) { return n + (n === 1 ? ' product' : ' products'); }
  function sectionId() { var g = document.querySelector('[data-sh-section]'); return g ? g.getAttribute('data-sh-section') : null; }
  function data() {
    var j = document.querySelector('[data-sh-part="bar"] .sh-json');
    if (!j) return null;
    try { return JSON.parse(j.textContent); } catch (e) { return null; }
  }

  /* a polite live region for result counts (outside the swapped parts, so it survives each swap) */
  var live = document.createElement('p');
  live.className = 'sx-sr';
  live.setAttribute('aria-live', 'polite');
  (document.querySelector('.page') || document.body).appendChild(live);

  /* ---------- quick add policy on the shop grids ---------- */
  function relabel(root) {
    $$('button[data-qadd]', root).forEach(function (b) {
      if (+b.getAttribute('data-variants') > 1) {
        var card = b.closest('.card'), a = card && card.querySelector('.qcard-a');
        b.setAttribute('aria-label', 'Choose options for ' + (a ? a.textContent.trim() : 'this product'));
      }
    });
  }
  relabel(document);
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('main button[data-qadd]') : null;
    if (!b || +b.getAttribute('data-variants') <= 1) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = b.getAttribute('data-url');
  }, true);

  /* ---------- after a filter or chip change: keep the page from collapsing onto the footer ---------- */
  var hdr = document.getElementById('hdr');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* a filtered grid keeps at least a screen's height (CSS .sh-gf), so fewer cards never pull the footer up */
  function markFiltered() {
    var g = document.querySelector('[data-sh-part="grid"]');
    if (!g) return;
    var on = false;
    new URL(window.location.href).searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) on = true; });
    g.classList.toggle('sh-gf', on);
  }
  markFiltered();
  /* when the new grid starts above the sticky stack (header and the filter bar), bring the chips row (or the
     filter bar) back to just under the header so the shopper sees the change from its first card */
  function settle() {
    var g = document.querySelector('[data-sh-part="grid"]');
    var anchor = document.querySelector('[data-sh-part="chips"]') || document.querySelector('[data-sh-part="bar"]');
    if (!g || !anchor) return;
    var h = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    var bar = document.querySelector('[data-sh-part="bar"]');
    var stack = h + (bar && window.getComputedStyle(bar).position === 'sticky' ? bar.getBoundingClientRect().height : 0);
    if (g.getBoundingClientRect().top >= stack - 1) return;
    /* the bar is sticky, so measure from the chips; without chips, from the grid less the bar */
    var top = anchor === bar ? g.getBoundingClientRect().top - (stack - h) : anchor.getBoundingClientRect().top;
    var y = Math.max(0, Math.round(top + window.pageYOffset - h - 8));
    window.scrollTo({ top: y, behavior: reduce.matches ? 'instant' : 'smooth' });
  }

  /* ---------- fetching a state ---------- */
  var busy = false, pending = null;
  function urlFor(href) {
    var u = new URL(href, window.location.href);
    u.searchParams.delete('section_id');
    return u;
  }
  /* where focus was, as (part, index among that part's focusables), to put it back after the swap */
  function focusSpot() {
    var a = document.activeElement, part = a && a.closest ? a.closest('[data-sh-part]') : null;
    if (!part) return null;
    return { part: part.getAttribute('data-sh-part'), i: ML.focusables ? ML.focusables(part).indexOf(a) : -1 };
  }
  function restoreFocus(spot) {
    if (!spot) return;
    var part = document.querySelector('[data-sh-part="' + spot.part + '"]');
    if (!part) return;
    var f = ML.focusables ? ML.focusables(part) : [];
    var el = f[Math.max(0, Math.min(spot.i, f.length - 1))];
    if (el) el.focus({ preventScroll: true });
  }
  function go(href, opts) {
    opts = opts || {};
    var id = sectionId();
    var u = urlFor(href);
    if (!id) { window.location.href = u.toString(); return Promise.resolve(); }
    if (busy) { pending = [href, opts]; return Promise.resolve(); }
    busy = true;
    var spot = opts.focus === false ? null : focusSpot();
    var grid = document.querySelector('[data-sh-part="grid"]');
    if (grid) { grid.setAttribute('aria-busy', 'true'); grid.classList.add('sh-busy'); }
    var f = new URL(u.toString());
    f.searchParams.set('section_id', id);
    return fetch(f.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['head', 'chips', 'bar', 'grid'].forEach(function (name) {
        var now = document.querySelector('[data-sh-part="' + name + '"]');
        var next = doc.querySelector('[data-sh-part="' + name + '"]');
        if (now && next) now.replaceWith(next);
        else if (now && !next) now.remove();
      });
      if (opts.push !== false) history.pushState({ sh: 1 }, '', u.toString());
      markFiltered();
      if (opts.push !== false) settle();
      relabel(document);
      var d = data();
      if (d) live.textContent = plural(d.count);
      deptFromHash();
      restoreFocus(spot);
      if (opts.after) opts.after();
    }).catch(function () {
      window.location.href = u.toString();
    }).then(function () {
      busy = false;
      var g = document.querySelector('[data-sh-part="grid"]');
      if (g) { g.removeAttribute('aria-busy'); g.classList.remove('sh-busy'); }
      if (pending) { var p = pending; pending = null; go(p[0], p[1]); }
    });
  }
  window.addEventListener('popstate', function () {
    if (!sectionId()) return;
    closePop(false);
    closeSheet(false);
    go(window.location.href, { push: false, focus: false });
  });

  /* ---------- department chips in place: Bestsellers and New Arrivals without a Product type filter ----------
     When the whole collection is on the page (main-collection loads up to 50 at once there), the chips carry
     data-sh-dept and the cards data-dept: a chip shows its department's cards, updates the counts and keeps the
     choice in the address (#kitchen), so a reload or a shared link opens on it. */
  var DEPTS = ['all', 'kitchen', 'dining', 'bed', 'bath', 'home'];
  function deptChips() { return $$('[data-sh-part="chips"] [data-sh-dept]'); }
  function deptFilter(d, opts) {
    opts = opts || {};
    var chips = deptChips();
    var part = document.querySelector('[data-sh-part="grid"]');
    var grid = part && part.querySelector('.sh-grid');
    if (!chips.length || !grid) return false;
    var cards = $$('.sh-c[data-dept]', grid);
    if (!cards.length) return false;
    var all = d === 'all', n = 0;
    cards.forEach(function (c) {
      var on = all || c.getAttribute('data-dept') === d;
      c.classList.toggle('sh-hide', !on);
      /* a department shows all of its cards; All goes back to the held first screen only on a fresh load */
      if (!all) c.classList.remove('sh-xd', 'sh-xp');
      if (on) n++;
    });
    chips.forEach(function (ch) {
      var k = ch.getAttribute('data-sh-dept'), on = k === d;
      ch.classList.toggle('is-on', on);
      if (on) ch.setAttribute('aria-current', 'true'); else ch.removeAttribute('aria-current');
      /* as on the server-side chips: the chosen chip drops its department colour for the ink outline */
      if (k !== 'all' && k !== 'home') ch.classList.toggle('chip--' + k, !on);
    });
    var held = $$('.sh-c', grid).some(function (c) { return c.classList.contains('sh-xd') || c.classList.contains('sh-xp'); });
    var more = part.querySelector('.sh-more');
    if (more) {
      var p = more.querySelector('p');
      if (!held) {
        if (p) p.textContent = 'Showing ' + n + ' of ' + n;
        $$('[data-sh-more][href="#main"]', more).forEach(function (b) { b.remove(); });
      }
    }
    var ct = document.querySelector('[data-sh-part="bar"] .sh-ct');
    if (ct) ct.textContent = plural(n);
    part.classList.toggle('sh-gf', !all);
    var u = new URL(window.location.href);
    u.hash = all ? '' : d;
    if (u.toString() !== window.location.href) history.replaceState(history.state, '', u.toString());
    if (opts.announce !== false) live.textContent = plural(n);
    if (opts.settle !== false) settle();
    return true;
  }
  function deptFromHash() {
    var h = window.location.hash.replace('#', '');
    if (DEPTS.indexOf(h) > 0 && deptChips().some(function (c) { return c.getAttribute('data-sh-dept') === h; })) {
      deptFilter(h, { announce: false, settle: false });
    }
  }
  deptFromHash();
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('main [data-sh-dept]') : null;
    if (!a) return;
    if (deptFilter(a.getAttribute('data-sh-dept'))) e.preventDefault();
  });

  /* chips, applied filters, Clear all, In stock: links and buttons that carry a state URL */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('main a[data-sh-go], main button[data-sh-href]') : null;
    if (!a) return;
    e.preventDefault();
    go(a.getAttribute('href') || a.getAttribute('data-sh-href'));
  });

  /* ---------- Show more ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('main [data-sh-more]') : null;
    if (!b || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var part = b.closest('[data-sh-part="grid"]'), grid = part.querySelector('.sh-grid');
    var more = b.closest('.sh-more');
    var held = $$('.sh-c', grid).filter(function (c) { return window.getComputedStyle(c).display === 'none'; });
    var line = more.querySelector('p');
    var total = (line.textContent.match(/of\s+(\d+)/) || [])[1];
    if (held.length) {
      $$('.sh-xd, .sh-xp', grid).forEach(function (c) { c.classList.remove('sh-xd', 'sh-xp'); });
      var n = $$('.sh-c', grid).length;
      line.textContent = 'Showing ' + n + (total ? ' of ' + total : '');
      if (b.getAttribute('href') === '#main') b.remove();
      focusCard(held[0]);
      live.textContent = 'Showing ' + n + (total ? ' of ' + total : '');
      return;
    }
    var id = sectionId(), href = b.getAttribute('href');
    if (!id || !href || href === '#main') return;
    var u = new URL(href, window.location.href);
    u.searchParams.set('section_id', id);
    b.setAttribute('aria-disabled', 'true');
    fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var np = doc.querySelector('[data-sh-part="grid"]');
      if (!np) throw new Error('no grid');
      var cards = $$('.sh-grid > .sh-c', np);
      cards.forEach(function (c) { grid.appendChild(c); });
      var tl = np.querySelector('.sx-tlist'), mine = part.querySelector('.sx-tlist');
      if (tl && mine) { $$('li', tl).forEach(function (li) { mine.querySelector('ul').appendChild(li); }); }
      else if (tl) more.parentNode.insertBefore(tl, more);
      var nm = np.querySelector('.sh-more');
      if (nm) more.replaceWith(nm); else more.remove();
      relabel(part);
      if (cards[0]) focusCard(cards[0]);
      var p = nm && nm.querySelector('p');
      if (p) live.textContent = p.textContent;
    }).catch(function () { window.location.href = href; });
  });
  function focusCard(c) {
    var a = c.matches('a') ? c : c.querySelector('a');
    if (a) a.focus();
  }

  /* ---------- desktop filter menus and the Sort menu ---------- */
  var pop = null; /* {el, btn, f} */
  function filterOf(k) {
    var d = data();
    if (!d) return null;
    for (var i = 0; i < d.filters.length; i++) if (d.filters[i].k === k) return d.filters[i];
    return null;
  }
  function priceURL(band) {
    var u = urlFor(window.location.href);
    var on = isBand(band);
    u.searchParams.delete(GTE);
    u.searchParams.delete(LTE);
    u.searchParams.delete('page');
    if (!on) {
      if (band[1] !== null) u.searchParams.set(GTE, band[1]);
      if (band[2] !== null) u.searchParams.set(LTE, band[2]);
    }
    return u.toString();
  }
  function isBand(band) {
    var p = new URL(window.location.href).searchParams;
    var g = p.get(GTE), l = p.get(LTE);
    return (band[1] === null ? !g : +g === band[1]) && (band[2] === null ? !l : +l === band[2]) && !!(g || l);
  }
  function sortURL(v) {
    var u = urlFor(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.set('sort_by', v);
    return u.toString();
  }
  function optsHTML(k) {
    var d = data();
    if (k === 'sort') {
      return d.sorts.map(function (s) {
        return '<button type="button" class="sh-opt" role="menuitemradio" aria-checked="' + (s.v === d.sort) + '" data-u="' + esc(sortURL(s.v)) + '">' + esc(s.l) + '</button>';
      }).join('');
    }
    var f = filterOf(k);
    if (!f) return '';
    var h = '<span class="sh-grp">' + esc(f.l) + '</span>', n = d.count;
    if (f.t === 'price') {
      h += BANDS.map(function (b) {
        var on = isBand(b);
        return '<button type="button" class="sh-opt' + (on ? ' is-on' : '') + '" role="checkbox" aria-checked="' + on + '" data-u="' + esc(priceURL(b)) + '"><span class="sh-box">' + (on ? TICK : '') + '</span>' + esc(b[0]) + '<span class="ct"></span></button>';
      }).join('');
    } else {
      h += f.v.map(function (v) {
        return '<button type="button" class="sh-opt' + (v.on ? ' is-on' : '') + '" role="checkbox" aria-checked="' + v.on + '" data-u="' + esc(v.u) + '"' + (!v.on && !v.n ? ' disabled' : '') +
          '><span class="sh-box">' + (v.on ? TICK : '') + '</span>' + esc(v.l) + '<span class="ct">' + (v.n === null ? '' : v.n) + '</span></button>';
      }).join('');
    }
    return h + '<span class="sh-popf"><button type="button" class="u" data-u="' + esc(f.clear) + '">Clear</button><span class="mute sh-pn">' + plural(n) + '</span></span>';
  }
  function findBtn(k) {
    if (k === 'sort') return $$('[data-sort]').filter(function (b) { return b.offsetParent !== null; })[0];
    return $$('.sh-bar .sh-fb[data-f]').filter(function (b) { return b.getAttribute('data-f') === k; })[0];
  }
  function openPop(btn, focusIdx) {
    closePop(false);
    if (!data()) return;
    var k = btn.hasAttribute('data-sort') ? 'sort' : btn.getAttribute('data-f');
    var el = document.createElement('div');
    el.className = 'sh-pop' + (k === 'sort' ? ' sh-pop--r' : '');
    el.setAttribute('role', k === 'sort' ? 'menu' : 'group');
    el.setAttribute('aria-label', k === 'sort' ? 'Sort' : (filterOf(k) || {}).l || 'Filter');
    el.innerHTML = optsHTML(k);
    btn.parentNode.appendChild(el);
    btn.setAttribute('aria-expanded', 'true');
    pop = { el: el, btn: btn, k: k };
    var os = $$('.sh-opt', el);
    var first = typeof focusIdx === 'number' ? os[Math.min(focusIdx, os.length - 1)] : (el.querySelector('.sh-opt[aria-checked="true"]') || os[0]);
    if (first) first.focus();
  }
  function closePop(focus) {
    if (!pop) return;
    var b = pop.btn;
    pop.el.remove();
    b.setAttribute('aria-expanded', 'false');
    pop = null;
    if (focus && b.isConnected) b.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = pop && t.closest ? t.closest('[data-u]') : null;
    if (o && pop && pop.el.contains(o)) {
      if (o.disabled) return;
      var k = pop.k, idx = $$('.sh-opt', pop.el).indexOf(o);
      if (k === 'sort') {
        closePop(false);
        go(o.getAttribute('data-u'), { focus: false, after: function () { var b = findBtn('sort'); if (b) b.focus(); } });
        return;
      }
      /* the menu stays open while ticking, as on the board: reopen it on the new bar */
      closePop(false);
      go(o.getAttribute('data-u'), { focus: false, after: function () { var b = findBtn(k); if (b) openPop(b, idx < 0 ? 0 : idx); } });
      return;
    }
    var b = t.closest ? t.closest('main .sh-bar .sh-fb[data-f], main [data-sort]') : null;
    if (b) {
      if (pop && pop.btn === b) closePop(false); else openPop(b);
    }
  });
  document.addEventListener('pointerdown', function (e) {
    if (pop && !pop.el.contains(e.target) && !pop.btn.contains(e.target)) closePop(false);
  });
  document.addEventListener('focusin', function (e) {
    if (pop && !pop.el.contains(e.target) && e.target !== pop.btn) closePop(false);
  });
  document.addEventListener('keydown', function (e) {
    if (!pop) return;
    if (e.key === 'Escape') { e.preventDefault(); closePop(true); return; }
    if (e.key === 'Tab' && pop.k === 'sort' && pop.el.contains(document.activeElement)) {
      var ms = $$('.sh-opt', pop.el), j = ms.indexOf(document.activeElement);
      e.preventDefault();
      ms[(j + (e.shiftKey ? ms.length - 1 : 1)) % ms.length].focus();
      return;
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var os = $$('.sh-opt:not(:disabled)', pop.el), i = os.indexOf(document.activeElement);
      if (!os.length) return;
      e.preventDefault();
      i = e.key === 'ArrowDown' ? Math.min(os.length - 1, i + 1) : Math.max(0, i - 1);
      os[i].focus();
    }
  });

  /* ---------- phone filter sheet ---------- */
  var sheet = null, sheetOpen = {}, untrap = null;
  function sheetBody() {
    var d = data();
    if (!d) return '';
    var h = '';
    if (d.stock) {
      h += '<button type="button" class="sh-row" data-u="' + esc(d.stock.u) + '" aria-pressed="' + d.stock.on + '"><span class="sh-l' + (d.stock.on ? ' is-on' : '') + '"><span class="sh-box">' + (d.stock.on ? TICK : '') + '</span>In stock</span><span class="sh-v"></span></button>';
    }
    d.filters.forEach(function (f) {
      var open = !!sheetOpen[f.k];
      var vals = f.t === 'price' ? BANDS.map(function (b) { return { l: b[0], on: isBand(b), u: priceURL(b), n: null }; }) : f.v;
      var k = vals.filter(function (v) { return v.on; }).length;
      var word = { Colour: 'colours', Size: 'sizes', Brand: 'brands', Price: 'ranges' }[f.l] || 'options';
      var sum = k ? k + ' chosen' : vals.length + ' ' + word;
      h += '<button type="button" class="sh-row' + (open ? ' sh-row--open' : '') + '" data-acc="' + esc(f.k) + '" aria-expanded="' + open + '"><span>' + esc(f.l) + '</span><span class="sh-v">' +
        (open ? '' : esc(sum)) + '<span style="display:flex' + (open ? ';transform:rotate(180deg)' : '') + '">' + CHEV_D + '</span></span></button>';
      if (open) {
        h += '<div class="sh-vals" role="group" aria-label="' + esc(f.l) + '">' + vals.map(function (v) {
          return '<button type="button" class="chip' + (v.on ? ' is-on' : '') + '" aria-pressed="' + v.on + '" data-u="' + esc(v.u) + '"' +
            (!v.on && v.n === 0 ? ' disabled' : '') + '><span>' + esc(v.l) + '</span>' + (v.n === null || v.n === undefined ? '' : '<span class="ct">' + v.n + '</span>') + '</button>';
        }).join('') + '</div>';
      }
    });
    return h;
  }
  function refreshSheet(focusSel, idx) {
    if (!sheet) return;
    var d = data();
    var body = sheet.querySelector('.sh-sh-body'), top = body.scrollTop;
    body.innerHTML = sheetBody();
    body.scrollTop = top;
    sheet.querySelector('.sh-go').textContent = 'Show ' + plural(d ? d.count : 0);
    var clear = sheet.querySelector('.sh-clear');
    if (d) clear.setAttribute('data-u', d.clear);
    if (focusSel) {
      var el = sheet.querySelector(focusSel) || $$('.sh-sh-body button', sheet)[idx || 0];
      if (el) el.focus();
    }
  }
  function openSheet(btn) {
    if (sheet || !data()) return;
    var d = data();
    if (!Object.keys(sheetOpen).length && d.filters.length) sheetOpen[d.filters[0].k] = true;
    sheet = document.createElement('div');
    sheet.innerHTML = '<div class="sh-scrim" aria-hidden="true"></div><div class="sh-sheet" role="dialog" aria-modal="true" aria-label="Filter">' +
      '<div class="sh-sh-top"><h2 class="lbl">Filter</h2><button type="button" class="ibtn" aria-label="Close filters">' + X_LG + '</button></div>' +
      '<div class="sh-sh-body"></div><div class="sh-sh-foot"><button type="button" class="u sh-clear">Clear all</button><button type="button" class="sh-go"></button></div></div>';
    (document.querySelector('.page') || document.body).appendChild(sheet);
    ML.lock(true);
    btn.setAttribute('aria-expanded', 'true');
    refreshSheet();
    if (ML.trap) untrap = ML.trap(sheet.querySelector('.sh-sheet'), function () { closeSheet(true); });
    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.sh-scrim') || t.closest('[aria-label="Close filters"]') || t.closest('.sh-go')) { closeSheet(true); return; }
      var acc = t.closest('[data-acc]');
      if (acc) {
        var k = acc.getAttribute('data-acc');
        sheetOpen[k] = !sheetOpen[k];
        refreshSheet('[data-acc="' + k.replace(/"/g, '\\"') + '"]');
        return;
      }
      var o = t.closest('[data-u]');
      if (o && !o.disabled) {
        var idx = $$('.sh-sh-body button', sheet).indexOf(o);
        go(o.getAttribute('data-u'), { focus: false, after: function () { refreshSheet(null); var el = $$('.sh-sh-body button', sheet)[Math.max(0, idx)] || sheet.querySelector('.sh-go'); if (el) el.focus(); } });
      }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSheet(true); }
    });
    sheet.querySelector('[aria-label="Close filters"]').focus();
  }
  function closeSheet(focus) {
    if (!sheet) return;
    if (untrap) { untrap(); untrap = null; }
    sheet.remove();
    sheet = null;
    ML.lock(false);
    var b = document.querySelector('[data-sh-sheet]');
    if (b) { b.setAttribute('aria-expanded', 'false'); if (focus) b.focus(); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('main [data-sh-sheet]') : null;
    if (b) openSheet(b);
  });

  var onMq = function () { closePop(false); if (sheet && mqL.matches) closeSheet(false); };
  if (mqL.addEventListener) mqL.addEventListener('change', onMq); else if (mqL.addListener) mqL.addListener(onMq);

  /* ---------- search page field ---------- */
  var sp = document.getElementById('sxp-q');
  if (sp) {
    var clr = sp.parentNode.querySelector('.sx-clear');
    sp.addEventListener('input', function () { if (clr) clr.hidden = !sp.value; });
    if (clr) clr.addEventListener('click', function () { sp.value = ''; clr.hidden = true; sp.focus(); });
    sp.form.addEventListener('submit', function (e) {
      var v = sp.value.trim().toLocaleLowerCase('en');
      if (!v) { e.preventDefault(); return; }
      sp.value = v;
    });
  }
})();
